import React from "react";
var __jsx = React.createElement;
import { createPortal } from "react-dom";
import { MantineThemeProvider } from "@/components/mantine-theme";
import { ComposerModal } from "@/components/composer-modal";
import { useComposerStore } from "@/stores/composers";

/**
 * Renders open composers as an overlay for the legacy patients view, which lacks the
 * patients-v2 `history-panel` portal host. A safety net for any src composer opened in the
 * old flow; letter/form/note actions there route to the legacy modals via overrides.
 */
export function LegacyComposerHost() {
  var composers = useComposerStore(function (state) {
    return state.composers;
  });
  var openComposers = composers.filter(function (composer) {
    return composer.status === "open";
  });
  if (!openComposers.length) return null;
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(MantineThemeProvider, null, openComposers.map(function (composer) {
    return /*#__PURE__*/React.createElement("div", {
      key: composer.id,
      className: "pointer-events-auto fixed inset-0 z-[1400] flex items-center justify-center bg-gray-900/40 p-6 dark:bg-gray-900/60"
    }, /*#__PURE__*/React.createElement(ComposerModal, {
      composer: composer
    }));
  })), document.body);
}